import { UploadComponent } from './upload/upload.component';
import { UploadInputComponent } from './upload-input/upload-input.component';
import { UploadQueueComponent } from './upload-queue/upload-queue.component';
import { UploadZoneComponent } from './upload-zone/upload-zone.component';
import { ValidationListComponent } from './validation-list/validation-list.component';

export const Components = [
	UploadComponent,
	UploadInputComponent,
	UploadQueueComponent,
	UploadZoneComponent,
	ValidationListComponent,
];
